export class Referee {
    name: string;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/referee.model.ts